export function getUserSignupItem(userSignupItems, signupItemID) {
  if (!userSignupItems) return null;
  if (!signupItemID) return null;

  try {
    return userSignupItems[signupItemID];
  } catch (e) {
    return null;
  }
}
